import mutations from './mutations';
import api from '../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    permissions: []
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    historyBudget({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.onePager
        .historyBudget(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          console.log(err);
          commit(mutations.LOADED);
          return err;
        });
    },
    historyApproval({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.onePager
        .historyApproval(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          console.log(err);
          commit(mutations.LOADED);
          return err;
        });
    },
    historySpending({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.onePager
        .historySpending(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err.response;
        });
    },
    detailSpending({ commit }, id) {
      commit(mutations.LOADING);
      return api.onePager
        .detailSpending(id)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    createGimmick({ commit }, gimmick) {
      commit(mutations.LOADING);
      return api.onePager
        .createGimmick(gimmick)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    },
    getRoi({ commit }, params = {}) {
      commit(mutations.LOADING);
      return api.onePager
        .getRoi(params)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(err => {
          commit(mutations.LOADED);
          return err;
        });
    },
    createCrm({ commit }, gimmick) {
      commit(mutations.LOADING);
      return api.onePager
        .createCrm(gimmick)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          return error;
        });
    }
  },
  getters: {
    permissions: state => state.permissions
  }
};
